import React from 'react';

export default function WaitingForTx({ content }) {
  return (
    <div className="alertcontain" role="alert">
      <div className="alert">
        <div className="row">
          <div className="col-12 col-md-2 p-0">
            {content.status === 'in progress' && <span className="badge bg-warning text-dark">{content.status}</span>}
            {content.status === 'validated' && <span className="badge bg-success text-dark">{content.status}</span>}
            {content.status === 'canceled' && <span className="badge bg-danger text-dark">{content.status}</span>}
          </div>
          <div className="col-12 col-md-10 waitTx">{content.message}</div>
        </div>
      </div>
    </div>
  );
}
